import { Api } from "./api"

export class GuestInvitationApi extends Api {
  constructor() {
    super('guest_invitations', ['url_token'])
  }
}
